/* 审核作品 */
import React, { useState, useEffect } from 'react'
import { infoCourse,auditCourse } from "../../../../http/modules/province";
import {
    Form,
    Input,
    Button,
    Radio,
    InputNumber,
    message,
} from 'antd';
import { LinkOutlined } from '@ant-design/icons';

export default function ReviewWorks(props) {

    const { reviewWorksId,setReviewWorks } = props
    // 课程详情
    const [course, setCourse] = useState()
    // 报名name
    const [baoMingName, setBaoMingName] = useState()
    // 附件
    const [fujianData, setFujianData] = useState()
    // 是否合规
    const [hegui, setHegui] = useState()
    // 初审分数
    const [score, setScore] = useState()

    // 课程详情
    const onListCourse = async () => {
        try {
            const res = await infoCourse({
                "courseUUID": reviewWorksId
            });
            if (res.code == 0) {
                let arr = []
                arr.push({
                    name: res.data.formName,
                    url: res.data.formUrl
                })
                setBaoMingName(arr)
                setFujianData(res.data.attachmentList)
                setCourse(res.data)
            }
        } catch (err) {
            message.error(err.response.data?.msg);
        }
    };

    // 提交
    const onFinish = async() => {
        if(hegui=='pass' && !score){
            return message.error('请输入成绩')
        }
        try {
            const res = await auditCourse({
                "courseUUID": reviewWorksId, 
                "hegui":hegui, // 合规 pass 不合规 reject 
                "score":score
            });
            if (res.code == 0) {
                message.success('提交成功')
                setReviewWorks(false)
            }else{
                message.error(res.msg)
            }
        } catch (err) {
            message.error(err.response.data?.msg);
        }
    }

    useEffect(() => {
        onListCourse()
    }, [])

    return (
        <div className='reviewWorks'>
            <header>
                <p></p>
                审核作品
            </header>
            <Form
                labelCol={{
                    span: 4,
                }}
                wrapperCol={{
                    span: 18,
                }}
                layout="horizontal"
            >

                <Form.Item
                    label="授课人"
                >
                    {course ? <Input defaultValue={course?.playerName} disabled={true} /> : ''}
                </Form.Item>

                <Form.Item label="课程名称" name='title'>
                    {course ? <Input defaultValue={course?.title} disabled={true} /> : ''}
                </Form.Item>

                <Form.Item label="课程类别" name='category'>
                    {course ? <Input defaultValue={course?.title} disabled={true} /> : ''}
                </Form.Item>

                <Form.Item label="授课类型" name='typ'>
                    {
                        course ? <Input defaultValue={course?.typ} disabled={true} /> : ''
                    }
                </Form.Item>

                <Form.Item wrapperCol={{
                    offset: 0,
                    span: 14,
                }} label="上传视频" valuePropName="fileList">
                    <>
                        {course ? <div className='video'>
                            <video src={course?.mainCourseUrl?.split("?")[0]} controls width={430} height={200}></video>
                            <span title={course.mainCourseName}> 课程名称：{course.mainCourseName}</span>
                        </div> : ''}
                        {course?.typ == '标准课程' ? <div className='video'>
                            <video src={course?.subCourseUrl?.split("?")[0]} controls width={430} height={200}></video>
                            <span title={course.subCourseName}> 课程名称：{course.subCourseName}</span>
                        </div> : ''}
                    </>
                </Form.Item>


                <Form.Item label="上传附件" valuePropName="fileList">
                    <div className='fujian'>
                        {baoMingName?.map((item) => {
                            return <p style={{ width: '100%' }}>
                                <LinkOutlined className='icon' /> <a target="_blank" href={item.url.split("?")[0]} download>{item.name}</a>
                            </p>
                        })}
                        {fujianData?.map((item) => {
                            return <p style={{ width: '100%' }}>
                                <LinkOutlined className='icon' /> <a target="_blank" href={item.url.split("?")[0]} download>{item.name}</a>
                            </p>
                        })}
                    </div>
                </Form.Item>

                <Form.Item label="合规性审查" name="remember" valuePropName="checked">
                    <Radio.Group onChange={(e) => {
                        setHegui(e.target.value)
                    }} defaultChecked={true} value={hegui}>
                        <Radio style={{ fontSize: '18px' }} value="pass"> 通过 </Radio>
                        <Radio style={{ fontSize: '18px' }} value="reject"> 未通过 </Radio>
                    </Radio.Group>
                </Form.Item>

                <Form.Item label="初审评分" name="" valuePropName="checked">
                    <InputNumber disabled={hegui=='pass'?false:true} onChange={(e) => setScore(e)} value={score} addonAfter="分" min={0} max={100} precision={1} placeholder='请输入0～100的数字' />
                </Form.Item>

                <Form.Item
                    wrapperCol={{
                        offset: 4,
                        span: 6,
                    }}>
                    <Button type="primary" htmlType="submit" className='queDing' onClick={onFinish}>
                        确定
                    </Button>
                    <Button onClick={()=>setReviewWorks(false)} type="primary" htmlType="submit" className='quXiao'>
                        取消
                    </Button>
                </Form.Item>

            </Form>
        </div>
    )
}
